import type React from 'react'
import styled, { css } from 'styled-components'

import type { ControlledPopoverProps, UncontrolledPopoverProps } from '@components/ui'
import { OldIconButton, Popover } from '@components/ui'

import FiltersIcon from './FiltersIcon'

function getVariantStyles(variant: FilterOptionsProps['variant']) {
  switch (variant) {
    case 'date':
      return css`
        width: 40px;
        height: 100%;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `
    case 'search':
      return css`
        width: 30px;
        height: 30px;
        margin-right: -5px;
      `
    default:
      throw new Error(`Invalid variant used: ${variant} for getVariantStyles`)
  }
}

const FilterIconButton = styled(OldIconButton)<{
  $variant: FilterOptionsProps['variant']
}>`
  ${({ $variant }) => getVariantStyles($variant)}
`

interface CommonFilterOptionsProps {
  children: React.ReactNode
  className?: string
  disabled?: boolean
  variant: 'date' | 'search'
}

type ControlledFilterOptionsProps = CommonFilterOptionsProps & Pick<ControlledPopoverProps, 'onOpenChange' | 'open'>
type UncontrolledFilterOptionsProps = CommonFilterOptionsProps & Pick<UncontrolledPopoverProps, 'onOpenChange' | 'open'>

export type FilterOptionsProps = ControlledFilterOptionsProps | UncontrolledFilterOptionsProps

export default function FilterOptions({ children, className, disabled = false, variant, ...rest }: FilterOptionsProps) {
  return (
    <Popover
      placement="bottom-end"
      trigger={
        <FilterIconButton $variant={variant} className={className} disabled={disabled}>
          <FiltersIcon />
        </FilterIconButton>
      }
      {...rest}
    >
      {children}
    </Popover>
  )
}
